import { Injectable } from "@snap/ts-inject";
import type { Observable } from "rxjs";
import { Subject } from "rxjs";
import { lensCoreFactory } from "../lens-core-module/loader/lensCoreFactory";
import type { LensCore } from "../lens-core-module/lensCore";
import { getLogger } from "../logger/logger";

const logger = getLogger("FrameEvents");

export interface FrameEvent {
    processingTimeMs: number;
}

/**
 * Subscribes to LensCore's frame processed events and emits them as an observable.
 * @internal
 */
export const frameEventsFactory = Injectable(
    "frameEvents",
    [lensCoreFactory.token] as const,
    (lensCore: LensCore): Observable<FrameEvent> => {
        const frameEventsSubject = new Subject<FrameEvent>();
        lensCore
            .setOnFrameProcessedCallback({
                onFrameProcessed: (frameEvent) => {
                    frameEventsSubject.next(frameEvent);
                },
            })
            .catch((error) =>
                logger.error(`Failed registering setOnFrameProcessedCallback with error: ${error.message}`)
            );

        return frameEventsSubject.asObservable();
    }
);
